const formatCurrency = currency => 
    value => {
        const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currency || 'USD',
            minimumFractionDigits: 2,
        })
        return formatter.format(value)
    }

export { formatCurrency }